import React from 'react'
import style from './MeetingConclusion.scss'

const MeetingConclusion = (props) => {
    const data = props.data;
    return (
        <>
            <div className="meeting-conclusion">
                <div className="conclusion-header">
                    {data.header}
                </div>
                <div className="conclusion-body" dangerouslySetInnerHTML={{ __html: data.body }} />
            </div>
            <div className="conclusion-image">
                <img src={data?.config?.conclusionImage} alt={data?.config?.conclusionImageAlt}></img>
            </div>
        </>
    )
}

export default MeetingConclusion;
